const settingsConstants = {
    ACTIVID_SUPPORT_NUMBER: "966530821154",
    SALLA_URL: "https://s.salla.sa/login"
};

export default settingsConstants;